import { Injectable } from '@angular/core';
import { ITaskInfo } from '../interfaces/task-info';
import { HttpClient } from '@angular/common/http';
import {
  IExtendedFullJobSequenceUpdateDTO,
  ISequenceUpdateDTO,
  ITaskSequenceJobOverviewDTO,
} from '../interfaces/task-sequence/task-sequence-interfaces';
import { IJobScreenOrderTasksTaskInfo } from '../components/job-screen/common/job-screen-job-details/job-screen-order-tasks.component';

@Injectable({
  providedIn: 'root',
})
export class TaskSequenceService {
  public url = '/api/task-sequences';

  constructor(private http: HttpClient) {}

  updateTaskSequences(tasks: ITaskInfo[]): Promise<any> {
    const orderId = tasks[0].orderId;

    const sequenceUpdateDTO: ISequenceUpdateDTO = {
      orderId: orderId,
      taskSequences: tasks.map((task) => ({
        taskId: task.id,
        sequenceId: task.taskSequence,
      })),
    };

    return this.http.put(`${this.url}/update-task`, sequenceUpdateDTO).toPromise();
  }

  updateTaskSequenceFromJobScreen(
    tasks: IJobScreenOrderTasksTaskInfo[],
    orderId: number,
  ): Promise<any> {
    const sequenceUpdateDTO: ISequenceUpdateDTO = {
      orderId: orderId,
      taskSequences: tasks.map((task) => ({
        taskId: task.id,
        sequenceId: task.taskSequence,
      })),
    };

    return this.http.put(`${this.url}/update-task`, sequenceUpdateDTO).toPromise();
  }

  updateFullJobSequence(job: ITaskSequenceJobOverviewDTO): Promise<any> {
    const sequenceUpdateDTO: IExtendedFullJobSequenceUpdateDTO = {
      jobId: job.jobId,
      orderSequences: job.orders.map((order) => ({
        orderId: order.orderId,
        sequenceId: order.sequence || null,
        taskSequences: order.tasks.map((task) => ({
          taskId: task.taskId,
          sequenceId: task.sequence || null,
        })),
      })),
    };

    return this.http.put(`${this.url}/update-full-job`, sequenceUpdateDTO).toPromise();
  }

  getJobOverview(jobId: number): Promise<ITaskSequenceJobOverviewDTO> {
    return this.http
      .get<ITaskSequenceJobOverviewDTO>(`${this.url}/job-overview/${jobId}`)
      .toPromise();
  }
}
